import { makeAutoObservable } from "mobx";
import { BreadcrumbItem } from "src/appStore";
import { loadSpecification } from "src/business/specification";
import { loadValueCatalog } from "src/business/valueCatalog/apiValueCatalog";
import { ZValueCatalog } from "src/business/valueCatalog/ZValueCatalog";
import { RemoteData } from "src/common/RemoteData";
import { MFormStore } from "src/components/MForm/MFormStore";
import { PageUrl } from "src/routes/PageUrl";

import { makeValueCatalogRecInfo } from "../ValueCatalogRecForm/makeValueCatalogRecInfo";

export type ValueCatalogRecNewData = {
  catalog: ZValueCatalog;
};

export const valueCatalogRecNewStore = makeAutoObservable({
  async init(valueCatalogId: string) {
    try {
      this.setData({ status: "wait" });
      const catalog = await loadValueCatalog(valueCatalogId);
      const spec = await loadSpecification("values", catalog.schema.id);

      const { meta, data } = makeValueCatalogRecInfo(spec);
      this.form.setMeta(meta);
      this.form.setInitialValues(data);

      const result = { catalog };
      this.setData({ status: "ready", result });
    } catch (error) {
      this.setData({ status: "error", error });
    }
  },
  form: new MFormStore(),
  data: { status: "none" } as RemoteData<ValueCatalogRecNewData>,
  setData(newData: RemoteData<ValueCatalogRecNewData>) {
    this.data = newData;
  },
  title: "Новая запись",
  get crumbs() {
    const result: BreadcrumbItem[] = [
      { title: "Каталоги значений", page: PageUrl.managementValueCatalogs },
    ];
    const { data, title } = this;
    if (data.status === "ready") {
      result.push({
        title: data.result.catalog.name,
        page: PageUrl.valueCatalog,
        params: { id: data.result.catalog.id },
      });
    }
    result.push({ title });
    return result;
  },
});
